import Vue from "vue";
//import { setInteractionMode, extend } from "vee-validate";
import {
  setInteractionMode,
  extend,
  ValidationProvider,
  ValidationObserver,
  localize,
} from "vee-validate/dist/vee-validate.full";

setInteractionMode("eager");

extend("emailAgain", {
  validate: (value, { other }) => value === other,
  message: "The email retype does not match.",
  params: [{ name: "other", isTarget: true }],
  lazy: true,
});

const knownCodes = [
  "ar",
  "az",
  "bg",
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "eu",
  "fa",
  "fi",
  "fr",
  "he",
  "hr",
  "hu",
  "id",
  "it",
  "ja",
  "ka",
  "ko",
  "lt",
  "lv",
  "mn",
  "ms_MY",
  "nb_NO",
  "ne",
  "nl",
  "nn_NO",
  "pl",
  "pt_BR",
  "pt_PT",
  "ro",
  "ru",
  "sk",
  "sl",
  "sq",
  "sr",
  "sr_Latin",
  "sv",
  "th",
  "tr",
  "uk",
  "vi",
  "zh_CN",
  "zh_TW",
];

export function loadVeeLocale(code) {
  let l = "en";

  if (knownCodes.includes(code.replace("-", "_"))) {
    l = code.replace("-", "_");
  } else if (knownCodes.includes(code.substring(0, 2))) {
    l = code.substring(0, 2);
  }

  return import(`vee-validate/dist/locale/${l}`).then((locale) => {
    localize(code, locale);
  });
}

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
